import React,{PureComponent} from 'react'
import {Switch,Route, Redirect} from 'react-router-dom'
// 报送贴纸管理
import InfringementConfirmationList from "@pages/CustomsDeclarationStickerManagement/InfringementConfirmation/List"; //侵权确认列表
import InfringementConfirmOperation from "@pages/CustomsDeclarationStickerManagement/InfringementConfirmation/ConfirmOperation/ConfirmOperation"; //侵权确认操作
import InfringementConfirmDetails from "@pages/CustomsDeclarationStickerManagement/InfringementConfirmation/Details/Details"; //侵权已确认详情
import InfringementReviewList from "@pages/CustomsDeclarationStickerManagement/InfringementReview/List"; // 侵权审核列表
import InfringementReviewOperation from "@pages/CustomsDeclarationStickerManagement/InfringementReview/ReviewOperation/ReviewOperation"; //侵权审核操作
import InfringementReviewDetails from "@pages/CustomsDeclarationStickerManagement/InfringementReview/Details/Details"; //侵权已审核详情

import InfringementCustomsCoding from '@pages/CustomsDeclarationStickerManagement/CustomsCoding/List';   // 海关编码列表
import InfringementCustomsCodingDetail from '@pages/CustomsDeclarationStickerManagement/CustomsCoding/Details/Details'; //填写海关编码详情
import CertificateReview from '@pages/CustomsDeclarationStickerManagement/CertificateReview/List';      //证书审核列表
import CertificateReviewDetail from '@pages/CustomsDeclarationStickerManagement/CertificateReview/Details/Details'; // 证书审核详情

import StickerBrand from '@pages/CustomsDeclarationStickerManagement/StickerBrand/List';    //设置贴纸品名列表
import StickerBrandDetail from '@pages/CustomsDeclarationStickerManagement/StickerBrand/Details/Details'; //设置贴纸品名详情
import NoCertificateManagement from "@pages/CustomsDeclarationStickerManagement/NoCertificateManagement/List";
import ProgressTracking from "@pages/CustomsDeclarationStickerManagement/ProgressTracking/List";


import StickerReview from "@pages/CustomsDeclarationStickerManagement/StickerReview/List"; //贴纸审核
import StickerReviewEdit from "@pages/CustomsDeclarationStickerManagement/StickerReview/Edit/Edit"; //侵权确认操作

class CustomsDeclarationStickerRouter extends PureComponent{
    render() {
        return (
            <Switch>
                {/*<Route path="/customsDeclarationSticker/infringementConfirmation/confirm" component={InfringementConfirmOperation} />*/}
                <Route path="/customsDeclarationSticker/infringementConfirmationWork" component={InfringementConfirmOperation} />
                {/* 详情 */}
                <Route path="/customsDeclarationSticker/infringementConfirmation/detail" component={InfringementConfirmDetails} />
                <Route path="/customsDeclarationSticker/infringement/detail" component={InfringementConfirmDetails} />
                {/*<Route path="/customsDeclarationSticker/infringementDetail:id" render={(props) => <Redirect to='/customsDeclarationSticker/infringementConfirmation/detail:id' />} />*/}
                {/*<Route path="/customsDeclarationSticker/infringementDetail"  render={(props) => <Redirect to='/customsDeclarationSticker/infringementConfirmation/detail' />} />*/}
                <Route path="/customsDeclarationSticker/infringementDetail" component={InfringementConfirmDetails} />
                <Route path="/customsDeclarationSticker/infringementConfirmation" component={InfringementConfirmationList} />

                <Route path="/customsDeclarationSticker/reviewWork" component={InfringementReviewOperation} />
                <Route path="/customsDeclarationSticker/reviewDetail" component={InfringementReviewDetails} />
                <Route path="/customsDeclarationSticker/review" component={InfringementReviewList} />

                <Route path="/customsDeclarationSticker/customsCodeDetail" component={InfringementCustomsCodingDetail} />
                <Route path="/customsDeclarationSticker/customsCodeIsView" component={InfringementCustomsCodingDetail} />
                <Route path="/customsDeclarationSticker/customsCoding" component={InfringementCustomsCoding} />

                <Route path="/customsDeclarationSticker/stickerBrandDetail" component={StickerBrandDetail} />
                <Route path="/customsDeclarationSticker/stickerBrandIsView" component={StickerBrandDetail} />
                <Route path="/customsDeclarationSticker/stickerBrand" component={StickerBrand} />

                <Route path="/customsDeclarationSticker/certificateReviewDetail" component={CertificateReviewDetail} />
                <Route path="/customsDeclarationSticker/certificateReviewIsView" component={CertificateReviewDetail} />
                <Route path="/customsDeclarationSticker/certificateReview" component={CertificateReview} />

                <Route path="/customsDeclarationSticker/noCertificateManagement" component={NoCertificateManagement} />
                <Route path="/customsDeclarationSticker/progressTracking" component={ProgressTracking} />

                {/* 贴纸审核 */}
                {/*<Route path="/customsDeclarationSticker/stickerReviewDetail" component={StickerReviewEdit} />*/}
                <Route path="/customsDeclarationSticker/stickerReviewEdit" component={StickerReviewEdit} />
                <Route path="/customsDeclarationSticker/stickerReviewDetail" component={StickerReviewEdit} />
                <Route path="/customsDeclarationSticker/stickerReview" component={StickerReview} />

                <Route path="/*" render={(props) => <Redirect to='/customsDeclarationSticker/infringementConfirmation' />} />


            </Switch>
        );
    }
};

export default CustomsDeclarationStickerRouter;